import React from "react";
import "./generic.scss";
import BrandLogos from "../BrandLogos";
import { getModuleValue } from "../../Helpers";

export default function Hero({ brands, bg, short, hideBranding, loggedIn }) {
  return (
    <div
      className={`hero ${short ? "short" : ""}`}
      style={{
        backgroundImage: `url(${
          loggedIn
            ? getModuleValue(bg, "hero_image", "file.url")
            : short
            ? getModuleValue(bg, "hero_image_short", "file.url")
            : getModuleValue(bg, "hero_image_unbranded", "file.url")
        })`,
      }}
    >
      {!hideBranding && <BrandLogos brands={brands} />}
    </div>
  );
}
